import React from 'react'

import { Flex, Icon, Text, useMediaQuery } from '@chakra-ui/react'
import { device } from '@helpers/mediaQueryBreakpoints'
import { FiCornerRightDown, FiCornerRightUp } from 'react-icons/fi'

import DesktopDisplay from './DesktopDisplay'
import MobileDisplay from './MobileDisplay'

interface MobileDesktopDisplayProps {
    mobileContent: { image: JSX.Element; description: string }
    desktopContent: { image: JSX.Element; description: string }
}

const MobileDesktopDisplay = ({ mobileContent, desktopContent }: MobileDesktopDisplayProps) => {
    const [isMobile] = useMediaQuery(device.sm)

    return !isMobile ? (
        <Flex w="450px" mx="auto" position="relative" h="lg">
            <DesktopDisplay
                media={desktopContent.image}
                backgroundPosition="center center"
                backgroundSize="cover"
                objectFit="fill"
            />

            <Text
                color="indigo.500"
                fontWeight="bold"
                fontSize="xs"
                zIndex={2}
                maxW="140px"
                align="end"
                position="absolute"
                bottom="70px"
                right="10px"
            >
                {desktopContent.description}
            </Text>

            <Icon
                as={FiCornerRightUp}
                color="indigo.500"
                w="8"
                h="8"
                position="absolute"
                bottom="120px"
                right="40px"
                transform="rotate(-45deg)"
            />

            <MobileDisplay
                media={mobileContent.image}
                transform={['scale(0.28) rotate(-15deg)']}
                top="-130px"
                left="-143px"
                isPositionRelative={false}
                backgroundPosition="center center"
                backgroundSize="cover"
                objectFit="contain"
            />

            <Text
                color="indigo.500"
                fontWeight="bold"
                fontSize="xs"
                zIndex={2}
                maxW="140px"
                align="start"
                position="absolute"
                bottom="5px"
                left="105px"
            >
                {mobileContent.description}
            </Text>

            <Icon
                as={FiCornerRightDown}
                color="indigo.500"
                w="8"
                h="8"
                position="absolute"
                bottom="15px"
                left="60px"
                transform="rotate(180deg)"
            />
        </Flex>
    ) : (
        <DesktopDisplay
            media={desktopContent.image}
            backgroundPosition="center center"
            backgroundSize="cover"
            objectFit="cover"
        />
    )
}

export default MobileDesktopDisplay
